import { useState } from 'react'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrailerModalLocations, trackTrailerActionClicked } from '../../events'
import {
  CourseTrailerModal,
  hasCourseTrailer,
  type TrailerProps,
} from '../CourseTrailerModal'

export const TrailerAction = ({ trailer }: { trailer: TrailerProps }) => {
  const { t } = useTranslation('@mc/next')
  const [isOpenTrailer, setIsOpenTrailer] = useState(false)

  if (!hasCourseTrailer(trailer)) return null

  const handleClick = () => {
    trackTrailerActionClicked({ slug: trailer.slug || '' })
    setIsOpenTrailer(true)
  }

  return (
    <>
      <Button
        kind='link'
        className='d-inline-flex flex-column mc-text--underline mc-p-0'
        onClick={handleClick}
        style={{ fontSize: '14px' }}
      >
        {t('course.hero.trailer.cta')}
      </Button>

      {isOpenTrailer && (
        <CourseTrailerModal
          trailer={trailer}
          location={TrailerModalLocations.HERO}
          onClose={() => setIsOpenTrailer(false)}
        />
      )}
    </>
  )
}
